import { render } from "./BookBoardView.vue?vue&type=template&id=f7205b00&scoped=true"
import script from "./BookBoardView.vue?vue&type=script&lang=js"
export * from "./BookBoardView.vue?vue&type=script&lang=js"

import "./BookBoardView.vue?vue&type=style&index=0&id=f7205b00&lang=scss&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7205b00"]])

export default __exports__